import React from 'react'
import LuxPlusMonthCalendarLogo from './components/LuxPlusMonthCalendarLogo'
import LuxPlusMonthHeroSubtitleContent from './components/LuxPlusMonthHeroSubtitleContent'
import LuxPlusMonthHeroTitleContent from './components/LuxPlusMonthHeroTitleContent'
import LuxPlusMonthTakeoverBackground from './components/LuxPlusMonthTakeoverBackground'
import LuxPlusMonthTakeoverOfferBanner from './components/LuxPlusMonthTakeoverOfferBanner'
import LuxPlusMonthTakeoverSearchBanner from './components/LuxPlusMonthTakeoverSearchBanner'
import { LUX_PLUS_MONTH_ALL_OFFERS_URL, LUX_PLUS_MONTH_CAMPAIGN_ID, LUX_PLUS_MONTH_TAKEOVER_END_DATE, LUX_PLUS_MONTH_TAKEOVER_ID, LUX_PLUS_MONTH_TAKEOVER_START_DATE } from './constants/luxPlusMonthTakeoverConstants'

const luxPlusMonthTakeoverConfig: App.SiteTakeoverConfig = {
  id: LUX_PLUS_MONTH_TAKEOVER_ID,
  startDate: LUX_PLUS_MONTH_TAKEOVER_START_DATE,
  endDate: LUX_PLUS_MONTH_TAKEOVER_END_DATE,
  regions: new Set(['AU', 'US', 'NZ', 'CA', 'CN', 'SG', 'HK', 'ID', 'IL', 'JP', 'MO', 'KR', 'MY', 'PH', 'QA', 'SA', 'ZA', 'TW', 'TH', 'AE', 'VN']),
  brands: new Set(['luxuryescapes']),
  campaignTags: new Set([LUX_PLUS_MONTH_CAMPAIGN_ID]),
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour' // Tour V2
  ]),
  backgroundElement: LuxPlusMonthTakeoverBackground,
  palette: 'inverse',
  heroSection: {
    title: <LuxPlusMonthHeroTitleContent />,
    subtitle: <LuxPlusMonthHeroSubtitleContent />,
    subtitleActionLink: LUX_PLUS_MONTH_ALL_OFFERS_URL,
    logo: <LuxPlusMonthCalendarLogo />,
    palette: 'inverse',
    carouselPalette: 'default',
    filters: [
      { label: 'Bonus Dining & Drinks', value: 'Dining & Drinks', type: 'holidayType' },
      { label: 'Family Friendly', value: 'Family Friendly', type: 'holidayType' },
      { label: 'Sun & Beach', value: 'Sun & Beach', type: 'holidayType' },
    ],
    verticals: new Set(['home'])
  },
  searchPage: {
    bannerContent: <LuxPlusMonthTakeoverSearchBanner />,
  },
  offerPage: {
    bannerContent: <LuxPlusMonthTakeoverOfferBanner />,
  },
  siteWide: {
    banner: {
      description: <LuxPlusMonthTakeoverOfferBanner withCta />,
      align: 'start',
      logo: undefined,
      exceptedRoutes: ['/:regionCode/lux-plus']
    },
  }
}

export default luxPlusMonthTakeoverConfig
